__turbopack_context__.v({
  "arrowBtns": "common_carousel-module-scss-module___naDWG__arrowBtns",
  "commonCarouselWrapper": "common_carousel-module-scss-module___naDWG__commonCarouselWrapper",
  "full_width": "common_carousel-module-scss-module___naDWG__full_width",
  "next": "common_carousel-module-scss-module___naDWG__next",
  "noscrollContainer": "common_carousel-module-scss-module___naDWG__noscrollContainer",
  "prev": "common_carousel-module-scss-module___naDWG__prev",
  "scrollable": "common_carousel-module-scss-module___naDWG__scrollable",
  "show_more": "common_carousel-module-scss-module___naDWG__show_more",
});
